"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _player = require("@/api/player/player");
var _user = require("@/api/user/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "name",
        placeholder: "姓名"
      }
      // {
      //   label: "所属学校",
      //   type: "select",
      //   model: "schoolId",
      //   options: [],
      //   placeholder: "所属学校",
      //   change: "matchChange"
      // }
      ],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "登录账号",
        prop: "loginName",
        isShow: true,
        width: "200"
      }, {
        name: "姓名",
        prop: "name",
        isShow: true,
        width: "100"
      }, {
        name: "负责人姓名",
        prop: "courseLeader",
        isShow: true,
        width: "150"
      }, {
        name: "课程负责人所在院系",
        prop: "faculty",
        isShow: true,
        width: "150"
      }, {
        name: "状态",
        prop: "isLock",
        isShow: true,
        width: "100"
        // isFormats: true
      }],
      funBtns: [
      // {
      //   size: "small",
      //   click: "morePublishout",
      //   icon: "iconfont icon-daochuExcel",
      //   name: "导出",
      //   type: "primary",
      // },
      // {
      //   size: "small",
      //   click: "morePublish",
      //   icon: "iconfont icon-Excledaoru",
      //   name: "导入",
      //   type: "primary",
      // },
      // {
      //   size: "small",
      //   click: "stopMore",
      //   icon: "el-icon-delete",
      //   name: "批量禁用",
      //   type: "danger"
      // },
      // {
      //   size: "small",
      //   click: "active",
      //   icon: "el-icon-delete",
      //   name: "批量启用",
      //   type: "primary"
      // },
      {
        size: "small",
        click: "add",
        icon: "",
        name: "新增",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "编辑",
        class: "edit",
        option: "modify",
        span: 3
      },
      // { name: "删除", class: "delet", option: "deleteById", span: 3 },
      {
        name: "启用",
        class: "edit",
        option: "active",
        span: 3
      }
      // { name: "禁用", class: "delet", option: "stopMore", span: 3 }
      ],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      expertId: "",
      keyWords: "",
      checkBoxs: []
    };
  },
  methods: {
    // 筛选
    search: function search(e) {
      this.keyWords = e.name;
      this.getTeacherLsit();
    },
    // 获取选手列表
    getTeacherLsit: function getTeacherLsit() {
      var _this = this;
      (0, _player.getTeacherList)({
        id: "",
        keyWords: this.keyWords,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNumber
      }).then(function (res) {
        var data = res.data;
        _this.listData = data.list;
        _this.listData.forEach(function (item) {
          if (item.isLock === 1) {
            item.isLock = "禁用";
          } else if (item.isLock === 0) {
            item.isLock = "启用";
          }
        });
        _this.totalData = data.total;
      });
    },
    // 新增
    add: function add() {
      this.$router.push({
        path: "/education/teacherList-add"
      });
    },
    modify: function modify(e) {
      console.log('pppp', e);
      this.$router.push({
        path: "/education/teacherList-add",
        query: {
          item: e
        }
      });
    },
    // 禁用
    stopMore: function stopMore(row) {
      var _this2 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      (0, _user.stopUser)({
        idList: id
      }).then(function () {
        _this2.getTeacherLsit();
        _this2.$message.success("操作成功。");
      });
    },
    // 取消禁用
    active: function active(row) {
      var _this3 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      (0, _user.activeUser)({
        idList: id
      }).then(function (res) {
        if (res.code === 2000) {
          _this3.$message.success("操作成功。");
          _this3.getTeacherLsit();
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this4 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this4.checkBoxs.push(item.id);
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getTeacherLsit();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getTeacherLsit();
    }
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  },
  created: function created() {
    this.getTeacherLsit();
  }
};